export enum Event {
  OpenNavigation,
  CloseNavigation,
}
